import React from 'react'
import ProjectCard from '../molecules/ProjectCard'
import { Project, ProjectViewMode } from 'src/types/projects'

interface ProjectGridProps {
  projects: Project[]
  mode: ProjectViewMode
  onOpenProject?: (project: Project) => void
  selectedIds?: Set<string>
  onToggleSelect?: (id: string) => void
}

const ProjectGrid: React.FC<ProjectGridProps> = ({ projects, onOpenProject, mode, selectedIds, onToggleSelect }) => {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(270px,1fr))] gap-6">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onOpen={onOpenProject}
          mode={mode}
          isSelected={selectedIds?.has(project.id)}
          onToggleSelect={onToggleSelect}
        />
      ))}
    </div>
  )
}

export default ProjectGrid
